import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import 'firebase/messaging'


const configOptions = {
  apiKey: "AIzaSyBa4ZHZTFKOK-qGn2T6oG8iFG7bxnXF7gs",
  authDomain: "betslip-tips.firebaseapp.com",
  databaseURL: "https://betslip-tips.firebaseio.com",
  projectId: "betslip-tips",
  storageBucket: "betslip-tips.appspot.com",
  messagingSenderId: "434036968842",
  appId: "1:434036968842:web:a63b8e92ca1607a7c94c73",
  measurementId: "G-LK0HY7VMW0",
};

firebase.initializeApp(configOptions);


firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};
if (firebase.messaging.isSupported()) {
  firebase.messaging()
}


export default firebase;
